import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, Typography, IconButton, Alert, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { PriorityHigh } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { notificationDangerCustomTime, notificationSuccess } from '../../../../utils/toastify';

import { CustomModal, useCustomModalToggle } from '../../../../common/Dialog/CustomModal';
import moment from 'moment';
import { useExampleUploadExcelDownload, useUploadEntriesMutation } from '../apiHooks';
import { getRecurringTransactionTypes } from '../../../../constants/transactionTypesRecurring.constants';
import { getAccountType } from '../../../../constants/accountType.constants';

const StyledBox = styled(Box)(({ theme }) => ({
  minWidth: '100%',
  border: '1px dotted red',
  padding: '10px',
}));

const UploadEntries = ({ disabled, recurringGeneralData }) => {
  const params = useParams();
  const [files, setFiles] = React.useState([]);
  const [errors, setErrors] = React.useState([]);
  const { toggleCustomModal, open } = useCustomModalToggle();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      setFiles([acceptedFiles[0]]);
    },
  });

  const onErrorResponseCallback = (responseErrors) => {
    setErrors(responseErrors);
  };

  const onSuccessResponseCallback = (data) => {
    if (data.errorsFromUpload && data.errorsFromUpload.length) {
      setErrors(data.errorsFromUpload);
      return;
    } else {
      toggleCustomModal();
    }
    console.log('first');
    notificationSuccess('Uploaded successfully!');
  };

  const { mutate: uploadEntriesMutation, data: { data: mutationResponse = {} } = {} } = useUploadEntriesMutation({
    errorCb: onErrorResponseCallback,
    successCb: onSuccessResponseCallback,
    recurringId: params.recurringId,
  });
  const { mutate: downloadExampleMutation } = useExampleUploadExcelDownload();

  const preparedFilesDisplay = React.useMemo(() => {
    return files.map((file) => (
      <>
        <Grid
          key={file.name}
          item
          xs={12}
          md={12}
          sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '2px 10px', backgroundColor: 'rgba(46,125,50, .2)' }}
        >
          <Typography sx={{ wordBreak: 'break-word' }}>{file.name}</Typography>
          <IconButton
            onClick={() => setFiles([])}
            sx={{
              color: (theme) => theme.palette.error,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </>
    ));
  }, [files]);

  const preparedErrorsDisplay = React.useMemo(() => {
    if (Array.isArray(errors)) {
      return errors.map((error) => (
        <Grid item xs={12} md={12} key={error} sx={{ mb: 2 }}>
          <Alert severity='error'>{error}</Alert>
        </Grid>
      ));
    }
    // if (errors.notify) {
    //   if (errors.amountErrors) {
    //     // console.log(errors);
    //     let notification = () => (
    //       <div>
    //         {errors.amountErrors.map((item, idx) => (
    //           <div key={idx}>
    //             Document Number: <strong className='text-danger'>{item.document_num}</strong>. Sum Amounts:
    //             <strong className='text-danger'>
    //               {item.amount.toLocaleString('us', {
    //                 style: 'currency',
    //                 currency: 'USD',
    //                 minimumFractionDigits: 2,
    //               })}
    //             </strong>
    //           </div>
    //         ))}
    //         <strong>Sum of amount must be $0.00 in grouped items by Posting Date and Document Number.</strong>
    //       </div>
    //     );

    //     notificationDangerCustomTime(notification, 15000);
    //     return { error: true };
    //   }

    //   // Throw formatted error if data is mismatched
    //   if (errors.dataMismatch) {
    //     let notification = () => (
    //       <div>
    //         {errors.dataMismatch.map((item, idx) => (
    //           <div key={idx}>
    //             <div>
    //               Transaction type: <strong className='text-danger'>{getRecurringTransactionTypes(item.transaction_type)}</strong>
    //             </div>
    //             <div>
    //               Account Type: <strong className='text-danger'>{getAccountType(item.client_type)}</strong>
    //             </div>
    //             <div>
    //               for Document Number: <strong>{item.document_num}</strong> cannot be posted.
    //             </div>
    //           </div>
    //         ))}
    //         <strong>Data Mismatch</strong>
    //       </div>
    //     );
    //     notificationDangerCustomTime(notification, 15000);
    //     return { error: true };
    //   }

    //   // Throw formatted error when data does not have client_id
    //   if (errors.hasClient) {
    //     let notification = () => (
    //       <div>
    //         {errors.hasClient.map((item, idx) => (
    //           <div key={idx}>
    //             Group with document number <strong className='text-danger'>"{item.document_num}"</strong> must have at least one row with Subbacount
    //             entered.
    //           </div>
    //         ))}
    //         <strong>Data Missing</strong>
    //       </div>
    //     );
    //     notificationDangerCustomTime(notification, 15000);
    //     return { error: true };
    //   }
    //   return;
    // }
    // let errorHTML = [];
    // for (const [key, errArray] of Object.entries(errors)) {
    //   errorHTML.push(
    //     <Grid item xs={12} md={12} key={key} sx={{ mb: 2 }}>
    //       <Alert severity='error'>Excel Row: {key}</Alert>
    //       <List>
    //         {errArray.map((item, idx) => (
    //           <ListItem key={idx}>
    //             <ListItemIcon>
    //               <PriorityHigh />
    //             </ListItemIcon>
    //             <ListItemText primary={item} />
    //           </ListItem>
    //         ))}
    //       </List>
    //     </Grid>
    //   );
    // }

    // return errorHTML;
  }, [errors.length]);

  const onUpload = () => {
    setErrors([]);
    const formData = new FormData();
    formData.append('file', files[0]);
    formData.append(
      'additionalData',
      JSON.stringify({
        creation_date: moment().format('YYYY-MM-DD'),
        recurringId: params.recurringId,
        end_date: recurringGeneralData.end_date,
        frequency: recurringGeneralData.frequency,
      })
    );

    if (files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      notificationDangerCustomTime('Please provide Excel file!', 5000);
      return;
    }

    uploadEntriesMutation({ formData, depositId: params.depositId });
  };

  const renderActionButtons = (
    <div className='d-flex align-items-center justify-content-between w-100'>
      <Button onClick={downloadExampleMutation} size='small' color='info'>
        Download Example File
      </Button>
      <Button autoFocus onClick={onUpload} color={'success'} size='small'>
        Upload
      </Button>
    </div>
  );

  return (
    <>
      <Button
        color='warning'
        size='small'
        onClick={() => {
          toggleCustomModal();
          setErrors([]);
          setFiles([]);
        }}
        disabled={disabled}
        sx={{ mr: 1 }}
      >
        Upload Entries
      </Button>
      <CustomModal
        modalTitle='Upload Entries'
        modalSize='sm'
        buttonClassName='btn-success'
        saveButtonTitle='Upload'
        onSave={onUpload}
        toggleCustomModal={toggleCustomModal}
        isOpen={open}
        addStyles={{ PaperStyle: { overflowY: 'scroll' } }}
        actionButtons={renderActionButtons}
      >
        <Grid container>
          {preparedErrorsDisplay}
          <Grid item sm={12} md={12} sx={{ mb: 2 }}>
            <StyledBox {...getRootProps()}>
              <Typography>{isDragActive ? 'Drop me here!' : `Drag 'n' drop or click to select files`}</Typography>
            </StyledBox>
          </Grid>
          {preparedFilesDisplay}
        </Grid>
      </CustomModal>
    </>
  );
};

export default UploadEntries;
